import { SbsState } from '@/store/modules/sbs.module';
import { ISbsState } from '@/store/modules/sbs.module';
import { getModule } from 'vuex-module-decorators';
import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistance from 'vuex-persist';

Vue.use(Vuex);

const storage = new VuexPersistance<ISbsState>({
    modules: ['sbs'],
    storage: window.sessionStorage
});

const store = new Vuex.Store({
    plugins: [storage.plugin],
    modules: {
        sbs: SbsState
    }
});

export default store;
export const sbsModule = getModule(SbsState, store);